import { apiSlice } from "@/redux/apiSlice";
import { ApiResponse } from "@/types";
import {
  FacilitySchedule,
  FacilityScheduleTable,
} from "@/types/facility/schedule";

// Events use the same schedule APIs with type="events"
export const eventApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query<
      FacilityScheduleTable,
      { org_id: number; query: string }
    >({
      query: ({ org_id, query }) => ({
        url: `/facility/schedule?org_id=${org_id}&${query}`,
        method: "GET",
      }),
      providesTags: ["Facility"],
    }),
    getEventById: builder.query<
      FacilitySchedule,
      { event_id: number; org_id: number }
    >({
      query: ({ event_id, org_id }) => ({
        url: `/facility/schedule/${event_id}?org_id=${org_id}`,
        method: "GET",
      }),
      providesTags: ["Facility"],
    }),
    createEvent: builder.mutation<ApiResponse, Partial<FacilitySchedule>>({
      query: (body) => ({
        url: `/facility/schedule`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["Facility"],
    }),
    updateEvent: builder.mutation<
      ApiResponse,
      Partial<FacilitySchedule> & { id: number }
    >({
      query: ({ id, ...body }) => ({
        url: `/facility/schedule/${id}`,
        method: "PUT",
        body: body
      }),
      invalidatesTags: ["Facility"],
    }),
    deleteEvent: builder.mutation<ApiResponse, { event_id: number; org_id: number }>({
      query: ({ event_id, org_id }) => ({
        url: `/facility/schedule/${event_id}?org_id=${org_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Facility"],
    }),
  }),
});

export const {
  useGetEventsQuery,
  useGetEventByIdQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
} = eventApi;
